import React, { useState } from 'react';
import { FadeIn } from './Shared';
import { Plus, Minus } from 'lucide-react';
const AccordionItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-navy-700" data-id="element-80">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none" onClick={() => setIsOpen(!isOpen)} data-id="element-81">
        <span className="text-lg font-medium text-white pr-8" data-id="element-82">{question}</span>
        {isOpen ? <Minus className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-83" /> : <Plus className="w-5 h-5 text-gold-400 flex-shrink-0" data-id="element-84" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-85">
        <p className="text-gray-200 leading-relaxed" data-id="element-86">{answer}</p>
      </div>
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Funciona para niños muy intensos o con alta sensibilidad?',
    a: 'Sí. El sistema está diseñado específicamente para niños con alta intensidad emocional. El Tomo 1 explica la neurología de los niños de alta reactividad y el Tomo 2 tiene un protocolo específico para el Anclaje Físico en niños de alta sensibilidad.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital en PDF. Inmediatamente después del pago recibís un email con el acceso a todos los archivos. En menos de 5 minutos tenés todo disponible para leer, imprimir o guardar en el celular.'
  }, {
    q: '¿Qué lo diferencia de lo que encuentro gratis en Instagram?',
    a: 'El contenido gratuito da conceptos. El MegaPack da protocolos. La diferencia es la misma que entre saber que el mate quema y tener el protocolo para curar la quemadura. Aquí tenés los pasos exactos, las frases exactas y las herramientas listas para usar en el momento de la crisis.'
  }, {
    q: '¿Sirve si mi pareja no está de acuerdo con la crianza respetuosa?',
    a: 'Sí. El sistema no es ideológico. Es práctico. Funciona desde distintos estilos de crianza porque se basa en neurología y psicología del desarrollo, no en una corriente específica. El Tomo 4 de Límites con Amor está especialmente diseñado para padres que valoran tanto la conexión como la autoridad.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin condiciones. Si lo abrís, lo usás y no te convence, escribís a mundopractico.oficial@gmail.com y te devolvemos el 100% sin preguntas.'
  }];
  return <section className="py-6 md:py-10 px-4 bg-navy-800/30" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <FadeIn data-id="element-89">
          <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-white mb-8" data-id="element-90">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="bg-navy-900 rounded-2xl border border-navy-700 p-6 md:p-8" data-id="element-91">
            {faqs.map((faq, index) => <AccordionItem key={index} question={faq.q} answer={faq.a} data-id="element-92" />)}
          </div>
        </FadeIn>
      </div>
    </section>;
};